import { Component } from "@angular/core";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    standalone: true,
    imports: [ProgressSpinnerModule],
})
export class LoadingComponent {
  
  constructor() {}

  ngOnInit(): void {}
}
